import { get, post } from '@/api/request.js'
import { requestData } from '@/common/js/commont.js'

// 获取触发记录
export const getTriggerRecordsList = data => post('/api/warn/getTriggerRecordsList', requestData(data))

// 获取用户设备接收参数
export const getDeviceParams = data => post('/api/device/getDeviceParams', requestData(data))

// 处理触发记录
export const handleTriggerRecord = data => post('/api/warn/handleTriggerRecord', requestData(data))
